import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/offers`,
});

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// ➕ Create Offer → Admin
export async function createOffer(payload) {
  try {
    const res = await API.post("/create", payload, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 📖 Get All Offers (paginated + filter) → Admin panel
export async function getAllPostOffers(payload) {
  try {
    const res = await API.post("/post", payload, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 📖 Get Single Offer by offerId or _id
export async function getOfferById(id) {
  try {
    const res = await API.get(`/get/${id}`, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 📋 Get Active Offers → Passenger app list
// optional: passengerId, vehicleType as query params
export async function getActiveOffers(passengerId = "", vehicleType = "") {
  try {
    let url = "/active";
    const params = [];
    if (passengerId) params.push(`passengerId=${passengerId}`);
    if (vehicleType) params.push(`vehicleType=${vehicleType}`);
    if (params.length) url += `?${params.join("&")}`;

    const res = await API.get(url, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ✅ Validate Offer Code → fare preview (passenger ride book பண்றதுக்கு முன்னாடி)
// payload: { code, passengerId, fareAmount, vehicleType? }
export async function validateOffer(payload) {
  try {
    const res = await API.post("/validate", payload, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 💾 Apply Offer → ride confirm ஆனா usage count increment
// payload: { offerCode, passengerId, rideId, fareAmount, vehicleType? }
export async function applyOffer(payload) {
  try {
    const res = await API.post("/apply", payload, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ✏️ Update Offer → Admin
export async function updateOffer(id, payload) {
  try {
    const res = await API.put(`/update/${id}`, payload, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 🔁 Toggle Active / Inactive → Admin quick switch
export async function toggleOfferStatus(id) {
  try {
    const res = await API.put(`/toggle/${id}`, {}, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 🗑️ Delete Offer → Admin
export async function deleteOffer(id) {
  try {
    const res = await API.delete(`/delete/${id}`, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}